import { render, staticRenderFns } from "./PayableForm.vue?vue&type=template&id=f2c9b9d6"
import script from "./PayableForm.vue?vue&type=script&lang=js"
export * from "./PayableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports